import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges} from '@angular/core';
import {Question} from '../../models/question.model';

@Component({
  selector: 'app-radio-cp-custom',
  templateUrl: './radio-cp-custom.component.html'
})
export class RadioCpCustomComponent implements OnInit, OnChanges {
    @Input() question: Question;
    @Input() idx: number;
    @Input() data: any;
    @Input() totalApp: number;
    @Input() statistic: boolean;
    @Input() loopCount: number;
    @Input() isViewResult;
    @Input() checkControlPanel: any;
    @Output() getFull = new EventEmitter<any>();
    @Output() getFinal = new EventEmitter<any>();
    @Output() getAllResult = new EventEmitter();

    numberApp: number;
    score: number = 0;
    valueRadio: number[] = [];
    numberRadio = 0;
    idData: number;
    applicantsFulfill: number;

    constructor() { }

    ngOnInit() {
      if (this.checkControlPanel != null) {
        this.statistic = true;
      }
        for (let item of this.data) {
            if(item['question_id'] == this.question.id) {
                this.score = item['score'];
                this.valueRadio = item['value'];
                this.numberRadio = item['number'];
                this.idData = item['id'];
                this.applicantsFulfill = item['applicants_fulfill'];
            }
        }
        this.getApp();
        this.getApplicantRadio();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.loopCount && this.loopCount > 0) {
            this.getApplicantRadio();
        }
    }

    onGetAllResult() {
        this.getAllResult.emit();
    }

    getOptionRadio(idx: number) {
      const id = this.question.options[idx].id;
        if (this.valueRadio.indexOf(this.question.options[idx].id) === -1) {
            this.valueRadio.push(id);
        } else {
            this.valueRadio.splice(this.valueRadio.indexOf(this.question.options[idx].id), 1);
        }
    }

  private getApp() {
    for (let item of this.question.options) {
      if(this.valueRadio.indexOf(item.id) != -1) {
        this.numberApp = this.numberApp ? this.numberApp + item['count']
          : item['count'];
      }
    }
  }

    getApplicantRadio() {
      let data  = {
        id: this.idData,
        question_id: this.question.id,
        type: this.question.type,
        value: this.valueRadio,
        score: this.score,
        applicants_fulfill: this.numberApp,
        options: this.question.options
      };
      if (typeof this.data !== 'undefined' && this.data.length > 0) {
        for (let item of this.data) {
          if(item['question_id'] == this.question.id) {
            data.id = item['id'];
          }
        }
      }
      if (this.score < 0 ) {
        this.score = 0;
      }
      if (this.score > 99) {
        this.score = 99;
      }

        this.calculateNumberApp();
        this.getFull.emit(data);
    }

    private calculateNumberApp() {
        let num = 0;

        for(let item of this.question.options) {
            if(this.valueRadio.indexOf(item.id) != -1) {
                num += item['count'];
            }
        }

        this.numberApp = num;
    }

}
